<div class="header">
  <div>
    <h2>{{ "pages.admin.referrals.title" | translate }}</h2>
  </div>
  <app-page-help>{{ "pages.admin.referrals.subtitle" | translate }}</app-page-help>
</div>

<nb-card>
  <nb-card-header>
    <h6><nb-icon icon="people-outline"></nb-icon>{{ "pages.admin.referrals.partners.title" | translate }}</h6>
  </nb-card-header>
  <nb-card-body>
    <div class="partners">
      @for (p of partners; track p.id) {
        <div class="partner">
          <div class="partner__head">
            <span class="partner__name">{{ p.name }}</span>
            <span class="chip">{{ "pages.admin.referrals.vat." + p.vat_mode | translate }}</span>
            <span class="chip">{{ "dialogs.referralPartner.billing." + p.billing_mode | translate }}</span>
            <span class="chip" [class.chip--on]="p.payout_mode === 'auto'">
              {{ (p.payout_mode === 'auto' ? "pages.admin.referrals.payout.autoOn" : "pages.admin.referrals.payout.manual")
                   | translate: { day: p.payout_day } }}
            </span>
            <span class="chip" [class.chip--on]="connect[p.id]?.transfers_active" [class.chip--warn]="!connect[p.id]?.transfers_active">
              {{ connectLabel(p) | translate }}
            </span>
          </div>
          @if (p.billing_via === "alphacount") {
            <p class="partner__preview">
              {{ "pages.admin.referrals.alphacount.active" | translate: { date: (p.alphacount_from | date: "dd.MM.yyyy") } }}
            </p>
          } @else if (p.alphacount_from) {
            <p class="partner__preview">
              {{ "pages.admin.referrals.alphacount.reporting" | translate: { date: (p.alphacount_from | date: "dd.MM.yyyy") } }}
            </p>
          }
          @if (p.ac_sync_error) {
            <p class="partner__missing">{{ "pages.admin.referrals.alphacount.problems" | translate }} {{ p.ac_sync_error }}</p>
          }
          @if (p.missing.length) {
            <p class="partner__missing">
              {{ "pages.admin.referrals.payout.missing" | translate: { fields: p.missing.join(", ") } }}
            </p>
          }
          @if (previews[p.id]; as pv) {
            <p class="partner__preview">
              {{ "pages.admin.referrals.payout.preview" | translate: { rows: pv.rows, net: eur(pv.net_cents), gross: eur(pv.gross_cents) } }}
            </p>
          }
          <div class="partner__actions">
            <button nbButton size="small" status="primary" outline (click)="editPartner(p)">
              <nb-icon icon="edit-outline"></nb-icon>{{ "pages.admin.referrals.payout.edit" | translate }}
            </button>
            @if (!connect[p.id]?.transfers_active) {
              <button nbButton size="small" status="basic" outline [disabled]="!p.email || onboardingBusy[p.id]"
                      [nbSpinner]="!!onboardingBusy[p.id]" nbSpinnerSize="small"
                      [nbTooltip]="'pages.admin.referrals.payout.onboardingNeedsEmail' | translate"
                      [nbTooltipDisabled]="!!p.email" (click)="createOnboardingLink(p)">
                <nb-icon icon="link-2-outline"></nb-icon>{{ "pages.admin.referrals.payout.onboarding" | translate }}
              </button>
            }
            @if (!hasAgreements(p)) {
              <button nbButton size="small" status="basic" ghost (click)="deletePartner(p)">
                <nb-icon icon="trash-2-outline"></nb-icon>{{ "pages.admin.referrals.payout.delete" | translate }}
              </button>
            }
            <button nbButton size="small" status="primary" outline
                    [disabled]="!previews[p.id]?.rows || running[p.id]" (click)="runPayout(p)">
              <nb-icon icon="paper-plane-outline"></nb-icon>{{ "pages.admin.referrals.payout.runNow" | translate }}
            </button>
          </div>
          @if (onboardingUrls[p.id]; as url) {
            <div class="onboarding-url">
              <input nbInput size="small" fullWidth readonly [value]="url" />
              <button nbButton size="small" ghost (click)="copy(url)" [attr.aria-label]="'pages.admin.referrals.payout.copy' | translate"
                      [nbTooltip]="'pages.admin.referrals.payout.copy' | translate">
                <nb-icon icon="copy-outline"></nb-icon>
              </button>
              <button nbButton size="small" ghost (click)="openUrl(url)" [nbTooltip]="'pages.admin.referrals.payout.open' | translate">
                <nb-icon icon="external-link-outline"></nb-icon>
              </button>
            </div>
            <div class="partner__actions">
              <button nbButton size="small" status="primary" [disabled]="mailBusy[p.id]" [nbSpinner]="!!mailBusy[p.id]"
                      nbSpinnerSize="small" (click)="mailOnboardingLink(p)">
                <nb-icon icon="email-outline"></nb-icon>{{ "pages.admin.referrals.payout.mailLink" | translate: { email: p.email } }}
              </button>
            </div>
            <p class="page-hint">{{ "pages.admin.referrals.payout.onboardingHint" | translate }}</p>
          }
        </div>
      }
      <div class="partner partner--new">
        <button nbButton size="small" status="primary" outline (click)="newPartner()">
          <nb-icon icon="plus-outline"></nb-icon>{{ "pages.admin.referrals.partners.add" | translate }}
        </button>
      </div>
    </div>
    <p class="page-hint">{{ "pages.admin.referrals.partners.hint" | translate }}</p>
  </nb-card-body>
</nb-card>

<nb-card>
  <nb-card-header>
    <h6><nb-icon icon="file-text-outline"></nb-icon>{{ "pages.admin.referrals.statements.title" | translate }}</h6>
  </nb-card-header>
  <nb-card-body>
    <app-table
      rowIdKey="id"
      [title]="'pages.admin.referrals.statements.title' | translate"
      [columns]="statementColumns"
      [data]="statements"
      [rowActions]="statementRowActions"
      [selectable]="false"
      (event)="onStatementEvent($event)"
    ></app-table>
    <p class="page-hint">{{ "pages.admin.referrals.statements.hint" | translate }}</p>
  </nb-card-body>
</nb-card>

<nb-card>
  <nb-card-header>
    <h6><nb-icon icon="briefcase-outline"></nb-icon>{{ "pages.admin.referrals.agreements.title" | translate }}</h6>
  </nb-card-header>
  <nb-card-body>
    <app-table
      rowIdKey="id"
      [title]="'pages.admin.referrals.agreements.title' | translate"
      [columns]="agreementColumns"
      [data]="agreements"
      [rowActions]="agreementRowActions"
      [globalActions]="agreementGlobalActions"
      [selectable]="false"
      (event)="onAgreementEvent($event)"
    ></app-table>
    <p class="page-hint">{{ "pages.admin.referrals.agreements.hint" | translate }}</p>
  </nb-card-body>
</nb-card>

<nb-card>
  <nb-card-header>
    <h6><nb-icon icon="credit-card-outline"></nb-icon>{{ "pages.admin.referrals.commissions.title" | translate }}</h6>
  </nb-card-header>
  <nb-card-body>
    <div class="filters">
      <nb-select size="small" [(selected)]="partnerFilter" (selectedChange)="onFilterChange()"
                 [placeholder]="'pages.admin.referrals.filter.partner' | translate">
        <nb-option [value]="null">{{ "pages.admin.referrals.filter.allPartners" | translate }}</nb-option>
        @for (p of partners; track p.id) {
          <nb-option [value]="p.id">{{ p.name }}</nb-option>
        }
      </nb-select>
      <nb-select size="small" [(selected)]="statusFilter" (selectedChange)="onFilterChange()"
                 [placeholder]="'pages.admin.referrals.filter.status' | translate">
        <nb-option [value]="null">{{ "pages.admin.referrals.filter.allStatuses" | translate }}</nb-option>
        @for (s of statuses; track s) {
          <nb-option [value]="s">{{ "pages.admin.referrals.status." + s | translate }}</nb-option>
        }
      </nb-select>
      <input
        nbInput
        size="small"
        class="reference"
        [(ngModel)]="payoutReference"
        [placeholder]="'pages.admin.referrals.referencePlaceholder' | translate"
      />
    </div>

    <div class="sums">
      <span>{{ "pages.admin.referrals.col.openNet" | translate }}: <strong>{{ eur(sums.open) }}</strong></span>
      <span>{{ "pages.admin.referrals.col.releasedNet" | translate }}: <strong>{{ eur(sums.released) }}</strong></span>
      <span>{{ "pages.admin.referrals.col.paidNet" | translate }}: <strong>{{ eur(sums.paid) }}</strong></span>
      <span class="sums__note">{{ "pages.admin.referrals.sumsNote" | translate }}</span>
    </div>

    <app-table
      rowIdKey="id"
      [title]="'pages.admin.referrals.commissions.title' | translate"
      [columns]="commissionColumns"
      [data]="commissions"
      [rowActions]="commissionRowActions"
      [globalActions]="commissionGlobalActions"
      [selectable]="true"
      [maxVisibleItems]="25"
      (event)="onCommissionEvent($event)"
    ></app-table>
    <p class="page-hint">{{ "pages.admin.referrals.commissions.hint" | translate }}</p>
  </nb-card-body>
</nb-card>
